import { render, staticRenderFns } from "./PartnersFilter.vue?vue&type=template&id=48aa3eb0&"
import script from "./PartnersFilter.vue?vue&type=script&lang=ts&"
export * from "./PartnersFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports